import { Tag, Link } from '@hh.ru/magritte-ui';
import { CheckOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import Conversion from 'bloko/blocks/conversion';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

const TrlKeys = {
    zero: 'score.0',
    one: 'score.1',
    some: 'score.2',
    many: 'score.5',
};

export interface TestResultProps {
    score: number;
    topicId: string;
}

const TestResult: TranslatedComponent<TestResultProps> = ({ score, topicId, trls }) => {
    return (
        <Link
            enableVisited={false}
            Element={SPALink}
            to={`/employer/vacancy_response/test?topicId=${topicId}`}
            target="_blank"
            data-qa="resume-serp__resume-score-link"
        >
            <Tag style="warning" icon={CheckOutlinedSize16}>
                <Conversion
                    zero={trls[TrlKeys.zero]}
                    one={trls[TrlKeys.one]}
                    some={trls[TrlKeys.some]}
                    many={trls[TrlKeys.many]}
                    value={score}
                />
            </Tag>
        </Link>
    );
};

export default translation(TestResult);
